module.exports = __webpack_public_path__ + "img/28.16944805.jpg";